/**!
 * Created by Leonardo Cheslacki on 27/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import {HelpersIcon} from './../helpers';

import config from '../../../../config';

const {default: {button}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StagePaginate extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            dynamic: false
        };

        const {current_name} = this.props;

        this.$helpersIcon = HelpersIcon(this)({current_name: current_name});

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param frame
         */
        handlePaginateMouseDown: function (event, {frame}) {
            _this.navigate(frame);
        }
    };

    /**
     *
     * @param frame
     */
    navigate = (frame) => {
        const
            _this_current = this.get(),
            _this_frame_old = this.getFrame();

        _this_current.gotoAndStop(frame);

        const
            _this_frame = this.getFrame(),
            differential = this.verifyField(this.state, 'differential'),
            camera = this.verifyField(this.state, 'camera'),
            pin = this.verifyField(this.state, 'pin'),
            dynamic = this.verifyField(this.state, 'dynamic');

        if (differential) {
            differential.setState({...differential.state, effect: false}, () => {
                const {enabled} = differential.props;
                enabled ? differential.show() : differential.close();
            });
        }

        if (camera) {
            camera.setState({...camera.state, effect: false}, () => {
                camera.close();
            });
        }

        if (pin) {
            pin.setState({...pin.state, effect: false}, () => {
                pin.close();
            });
        }

        if (dynamic) {
            const
                {current_name} = this.props,
                number_current = this.toNumber(frame),
                icon_current = `occ_icon_frame${this.padWithLeadingZeros(number_current, 2)}`,
                pseudo_current = `occ_pseudo_frame${this.padWithLeadingZeros(number_current, 2)}`,
                btn_current = `btn_frame${this.padWithLeadingZeros(number_current, 2)}`,
                children = _this_current.children;

            let reference = this.toSlug((`dynamic_paginate-${current_name || document.baseURI}`));

            this.main.getListener(reference) && this.main.emit('dynamic_paginate', {
                number_current: number_current,
                _this_frame_old: _this_frame_old
            }, current_name, true);

            if (this.isArrayIf(children)) {

                for (let property of children) {
                    if (this.hasString(property.name, 'occ_icon_frame')) {
                        property.occ_effect.occ_animate.visible = (property.name !== icon_current);
                    }

                    if (this.hasString(property.name, 'occ_pseudo_frame')) {
                        property.visible = (property.name === pseudo_current);
                    }

                    if (this.hasString(property.name, 'btn_frame')) {
                        property.visible = (property.name !== btn_current);
                    }
                }
            }
        }

        _this_frame.gotoAndPlay('start');
    };

    startPaginate = () => {
        const
            {current_page} = this.props,
            _this_current = this.get(),
            {totalFrames} = _this_current;

        let index = 1;

        /**
         *
         *  Add event in button for paginate in frame.
         */
        while (index < totalFrames) {
            let
                occurrence = this.padWithLeadingZeros(index, 2),
                property = this.verifyField(_this_current, `btn_frame${occurrence}`);

            if (property) {
                let handle_name = this.toHandleName(property.name, 'paginate');

                this[handle_name] && property.off('mousedown', this[handle_name]);
                this[handle_name] = property.on('mousedown', this.$functions.handlePaginateMouseDown, false, false, {
                    frame: `frame${occurrence}`
                });
            }

            index++;
        }

        this.$helpersIcon.disabledAnimate(_this_current)(this.toNumber(current_page));
    };

    /**
     *
     * @param {boolean} dynamic
     */
    initPaginate = (dynamic = false) => {
        this.setState({...this.state, dynamic: dynamic});
        this.startPaginate();
    };
}

/**
 *
 * @type {{}}
 */
StagePaginate.propTypes = {
    current_name: PropTypes.string,
    current_page: PropTypes.string
};

/**
 *
 * @type {{}}
 */
StagePaginate.defaultProps = {
    current_name: null,
    current_page: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StagePaginate, {className: 'StagePaginate'});
